module.exports = __webpack_public_path__ + "files/logo_htw_dresden.svg";